<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('p-super-admin')" class="admin-superpro">
      <div class="mb-2 p-2 border-bottom border-light">
        <h5 class="font-weight-light">
          <span><i class="fa-light fa-money-check-dollar-pen fa-lg"></i></span>
          Estornar Crédito
        </h5>
      </div>
      <Loading v-if="isLoading" class="loading" loadingText="Carregando..." />
      <b-form v-else>
        <b-form-row>
          <b-col cols="12" md="6" lg="4" class="mt-3 mt-lg-3 form-group">
            <label for="input-idUser">ID do Usuário: <span class="text-danger">*</span></label>
            <b-input-group>
              <b-form-input size="sm" type="text" placeholder="ID" v-model.trim="idUsuario"></b-form-input>
              <b-input-group-append class="append">
                <i class="fa-regular fa-user"></i>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col cols="12" md="6" lg="4"
            class="mt-md-3 mt-lg-3 d-flex align-items-center justify-content-center justify-content-md-start">
            <b-button class="shadow-none btn btn-primary border-primary w-auto"
              @click="pos_credito_user">Confirmar</b-button>
          </b-col>
        </b-form-row>
      </b-form>
      <div v-if="put_estorno_credito.length == 0"></div>
      <div v-else>
        <ul>
          <li>Erro: {{ put_estorno_credito.data.estornoCreditoUser.erro }}</li>
          <li v-if="put_estorno_credito.data.estornoCreditoUser.erro">
            Mensagen: {{ put_estorno_credito.data.estornoCreditoUser.msg }}
          </li>
          <li>Status: {{ put_estorno_credito.data.estornoCreditoUser.status }}</li>
          <li v-if="put_estorno_credito.data.estornoCreditoUser.xml">
            <ul>
              <li>Id Usuário {{ put_estorno_credito.data.estornoCreditoUser.xml.status.msg }}</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import ApiService from '../../../../../common/api.service';

export default {
  components: { Loading: () => import('@/components/loading.vue') },
  data() {
    return {
      isLoading: false,

      NamePermission: '',
      IndexPermission: '',
      spiner: false,
      put_estorno_credito: [], //289439
      idUsuario: '',
      credito: '',
    };
  },

  async mounted() {
    if (this.$route.query.loading) {
      this.isLoading = true;
      try {
        await this.fetchData();
      } catch (error) {
        console.error("ERROR loading data: ", error)
      } finally {
        this.isLoading = false
      }
    }
  },

  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions;
    },
    error503() {
      return (window.location.href = '/nao-autorizado');
    },
    formattedCredito() {
      // Formatar o valor do crédito
      if (this.credito === '') return '';
      let value = parseFloat(this.credito.toString().replace(/[^\d]/g, '')) / 100;
      return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
  },

  methods: {
    async fetchData() {
      await new Promise((resolve) => setTimeout(resolve, 1000))
    },

    temPermissao(permissao) {
      return this.permissions.includes(permissao);
    },
    pos_credito_user() {
      // this.isLoading = true;
      this.spiner = true;
      ApiService.get('v1/callEstorno', {
        idUsuario: this.idUsuario,
        credito: this.credito,
      })
        .then((response) => {
          this.put_estorno_credito = response;
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          // this.isLoading = false
        });
    },

  },
};
</script>

<style scoped>
.loading {
  height: 25vh;
}

.form-group label {
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
  letter-spacing: 0;
  color: #2d1a42;
  margin-bottom: 0;
}

.append {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 12%;

  background-color: #f8f8f8;
  border: 1px solid #bfc9d4;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.show-password {
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

input::placeholder {
  color: #c2b9ca;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
}

.btn {
  margin-top: 4px;
  padding: 7px 16px;
}

.btn:disabled {
  border: 0px solid #00000000 !important;
}
</style>
